import React, { memo } from 'react';

import classnames from 'classnames';

const namespace = 'ui-search-fullsnackbar-skeleton';

const Circle = memo(() => <div className={classnames(namespace, `${namespace}__circle`)} />);

Circle.displayName = 'Circle';

export default Circle;
